import { useEffect, useState } from "react";

import './header.scss';
import { Link, useLocation } from "react-router-dom";
import CommonModal from "../../../components/CommonModal";
import ContactForm from "../../../components/ContactForm";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 180);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleSubmenu = (menu: string) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <header id="header" className="bg-white header">

        {/* <div className="topbar">
        <div className="container d-flex justify-content-between hjfbef">
          <h4 className="mb-0">
            Now Hiring: IT Support Engineer?
          </h4>
          <div>
            <i className="bx bxs-phone"></i> +91 9876543210
          </div>
        </div>
      </div> */}

        <div className={`sticky-top ${isSticky ? "is-fixed" : ""}`}>
          <div className="container">
            <nav className="navbar">

              <Link className="logo" to={"/"}><img height={70} src="./assets/images/logo.jpg" alt="" /></Link>


              <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                <i className={`bx ${menuOpen ? "bx-x" : "bx-menu"}`}></i>
              </div>

              <ul className={`nav-menu align-items-center ${menuOpen ? "active" : ""}`}>

                <li className={location.pathname === "/" ? "active" : ""}>
                  <Link to="/">Home</Link>
                </li>

                <li className={location.pathname === "/about" ? "active" : ""}>
                  <Link to="/about">About Us</Link>
                </li>

                <li className={location.pathname === "/services" ? "active" : ""}>
                  <Link to="/services">Services</Link>
                </li>

                <li className={location.pathname === "/contact" ? "active" : ""}>
                  <Link to="/contact">Contact</Link>
                </li>

                {/* <li className={`nav-item ${activeMenu === "about" ? "dropdown" : ""}`}>
                <a href="#" onClick={() => toggleSubmenu("about")}>
                  About us <i className="bx bxs-chevron-down"></i>
                </a>

                <ul className="submenu">
                  <li><a href="#">Company</a></li>
                  <li><a href="#">Why Choose Us</a></li>
                </ul>
              </li>

              <li className={`nav-item ${activeMenu === "services" ? "mega" : ""}`}>
                <a href="#" onClick={() => toggleSubmenu("services")}>
                  Services <i className="bx bxs-chevron-down"></i>
                </a>

                <ul className="megamenu list-unstyled">
                  <li>
                    <h4>Software</h4>
                    <ul className="list-unstyled">
                      <li><a href="#">Application Development</a></li>
                      <li><a href="#">Blockchain Development</a></li>
                    </ul>
                  </li>

                  <li>
                    <h4>Development</h4>
                    <ul className="list-unstyled">
                      <li><a href="#">Application Development</a></li>
                      <li><a href="#">Blockchain Development</a></li>
                    </ul>
                  </li>

                  <li>
                    <h4>Solutions</h4>
                    <ul className="list-unstyled">
                      <li><a href="#">Application Development</a></li>
                      <li><a href="#">Blockchain Development</a></li>
                    </ul>
                  </li>

                  <li>
                    <h4>CRM</h4>
                    <ul className="list-unstyled">
                      <li><a href="#">Application Development</a></li>
                      <li><a href="#">Blockchain Development</a></li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li className={`nav-item ${activeMenu === "products" ? "mega" : ""}`}>
                <a href="#" onClick={() => toggleSubmenu("products")}>
                  Products <i className="bx bxs-chevron-down"></i>
                </a>

                <div className="megamenu">
                  <div className="mega-column">
                    <h4>Category 1</h4>
                    <a href="#">Product 1</a>
                  </div>

                  <div className="mega-column">
                    <h4>Category 2</h4>
                    <a href="#">Product 2</a>
                  </div>
                </div>
              </li>

              <li className={`nav-item ${activeMenu === "consulting" ? "dropdown" : ""}`}>
                <a href="#" onClick={() => toggleSubmenu("consulting")}>
                  Consulting <i className="bx bxs-chevron-down"></i>
                </a>

                <ul className="submenu">
                  <li><a href="#">Web Design</a></li>
                  <li><a href="#">Development</a></li>
                  <li><a href="#">SEO</a></li>
                </ul>
              </li> */}
                <button className="btn gwcs-btn px-4" onClick={() => setShowModal(true)} >Get in Touch</button>
              </ul>

              {menuOpen && <div className="menu-overlay" onClick={() => setMenuOpen(false)}></div>}
            </nav>
          </div>
        </div>

      </header>

      <CommonModal
        show={showModal}
        onClose={() => setShowModal(false)}
      >
        <div className="contact-modal">
          <div className="contact-left rounded-start-2 text-center d-flex flex-column justify-content-center text-white">
            <h1 className="fw-bold">Connect With Our Expert Team</h1>
            <p>
              We’re here to help bring your ideas to life. Share your requirements and our team will connect with you shortly.
            </p>
            <ul className="social-links justify-content-center">
              <li>
                <a href="/">
                  <i className="bx bxl-facebook"></i>
                </a>
              </li>

              <li>
                <a href="/">
                  <i className="bx bxl-linkedin"></i>
                </a>
              </li>

              <li>
                <a href="/">
                  <i className="bx bxl-instagram"></i>
                </a>
              </li>

              <li>
                <a href="/">
                  <i className="bx bxl-youtube"></i>
                </a>
              </li>
            </ul>

            {/* <ul className="contact-info">
              <li>📞 +91 98765 43210</li>
              <li>📧 support@example.com</li>
              <li>📍 Kanpur, India</li>
            </ul> */}
          </div>

          <div className="contact-right rounded-end-2">
            <form>
              <div className="form-group">
                <input type="text" placeholder="Full Name" required />
              </div>

              <div className="form-group">
                <input type="email" placeholder="Email Address" required />
              </div>

              <div className="form-group">
                <input type="tel" placeholder="Mobile Number" />
              </div>

              <div className="form-group">
                <textarea placeholder="Your Message"></textarea>
              </div>

              <button type="submit" className="btn-submit">
                Submit Request
              </button>
            </form>
          </div>

        </div>
      </CommonModal>
    </>
  );
};

export default Header;